module.exports = __webpack_public_path__ + "img/level3addon_idle_gun_mask.2bddde43.png";